import React from 'react';
import HeaderIconsWithDropdowns from '../../components/layout/HeaderIconsWithDropdowns';

const Discover: React.FC = () => {
  return (
    <div className="flex flex-col h-screen bg-gray-50">
      {/* Header Row */}
      <div className="flex items-center justify-between mt-6 mx-8" style={{minHeight: '64px'}}>
        <div>
          <h1 className="text-3xl font-bold text-gray-900" style={{fontFamily: 'Plus Jakarta Sans, sans-serif'}}>Discover</h1>
          <p className="text-gray-600 text-base mt-0.5" style={{fontFamily: 'Plus Jakarta Sans, sans-serif'}}>Find your next favorite book</p>
        </div>
        <div className="flex items-center">
          <HeaderIconsWithDropdowns />
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 p-8">
        {/* Add your content here */}
      </div>
    </div>
  );
};

export default Discover; 